<template>
    <section style="display: flex;   width: 100%;  flex-flow: column; margin: 1rem;">        
        
        <section class="box">         
        <div class="toolbar box is-fixed">
            <b-field grouped group-multiline>                               
                <div class="control is-expanded">
                    <b-input placeholder="Поиск..." type="search" icon="search" v-model="searchString"></b-input>
                </div>            

                <div v-if="selected" class="control">
                    <button class="button" @click="confirmDelete">Удалить</button>
                </div>
            </b-field>
        </div>
        </section>

        <div class="container has-toolbar">

        <b-table @click="editItem" @select="onSelect" @dblclick="onDblClick"
            :class="'project-list'"
            :data="isEmpty ? [] : filteredList"
            :loading="loading"
            :row-class="(row, index) => 'row ' + 'row-'+index"
            :icon-pack="'fas'"
            :bordered="true"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :focusable="true"
            :selected.sync="selected"  
            @sort="onSort"            
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"            
            :mobile-cards="true">

            <template slot-scope="props">
                 <b-table-column field="id" label="ID" width="40" :visible=true sortable numeric>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="title" label="Наименование" :custom-sort="sortText" sortable>
                    {{ props.row.title }}
                </b-table-column> 

                <b-table-column field="client" label="Заказчик" :custom-sort="sortText" sortable>
                    {{ props.row.client }}
                </b-table-column>  

                <b-table-column field="worker" label="Подрядчик" :custom-sort="sortText" sortable>
                    {{ props.row.worker }}
                </b-table-column>

                <b-table-column field="object" label="Объект" :custom-sort="sortText" sortable>
                    {{ props.row.object }}
                </b-table-column>

                <b-table-column field="object_address" label="Адрес объекта" :custom-sort="sortText" sortable>
                    {{ props.row.object_address }}
                </b-table-column>                

                <b-table-column field="totals" label="Сумма" width="200" sortable numeric>
                    <b-input :ref="`qty${props.row.id}`"  type="number" :class="'with-arrows'" min="0" max="999999" maxlength="6" placeholder="0,00" v-model="props.row.totals"></b-input>
                </b-table-column>                                

                <b-table-column field="dateCreated" label="Дата создания" :custom-sort="sortDateCreated" centered sortable>
                     {{ props.row.dateCreated }}
                </b-table-column>

                <b-table-column field="dateSaved" label="Дата сохранения" :custom-sort="sortDateSaved" centered sortable>
                     {{ props.row.dateSaved }}
                </b-table-column>                

                <b-table-column label="Статус" class="status" field="completed" centered sortable>
                     <b-checkbox v-model="props.row.completed" />
                 <!--    <b-icon pack="fas fa-xs" :icon="props.row.completed === 0 ? 'pen' : 'check'"></b-icon>  -->
                </b-table-column>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered is-large">
                        <p>
                            <b-icon pack="far fa-x7" icon="frown" size="is-large"></b-icon>
                        </p>
                        <p v-if="searchString">Ничего не найдено.</p>
                    </div>
                </section>
            </template>  
        </b-table>

    </div>

    </section>


    
</template>

<script>
//<custom-element v-bind:whatever="[...array]"></custom-element>
import searchMixin from '@/components/mixins/listFilterByTitle';
import tableItems from '@/components/mixins/projectList_table';
export default {
    name: 'project-list',
    template: '<project-list />',
    props: {
        listType:{type: String, default: ''}
    },
    mixins: [searchMixin, tableItems],
    data (){
        return {
            loading: false,
            searchString: '',
            searchField: 0,
            searchDate: null,
            selected: null,
            row: null,
            sortField: 'sortDateSaved',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',                                  
            filterType: ''
        }
    },
    
    computed:{
        isEmpty(){
            return !this.items.length > 0;
        },

        cols(){
            return JSON.stringify(this.selected);
        },

        itemsStr(){
            return JSON.stringify(this.items)
        },

        filteredByType(){
            let listType = this.listType;
            if (this.listType === '') { return this.items }
            return this.items.filter( function(item) {
                    return item.type === listType;
            })
        },
        
        filteredList(){
            let searchString = this.searchString;
            if (this.searchString === '') {return this.filteredByType}
            return this.filteredByType.filter( function(item) {
                return item.title.toLowerCase().includes(searchString.toLowerCase());
            })
        }
    },

    methods:{
        setListType(listType){
            this.filterType = listType
        },

        editItem(row){
            //this.$toast.open('проект ' + item.id)
            //console.dir(this.items[item.id].completed);
            //console.dir(item);
            //this.items.splice(row, 1);
        },
        
        updateItem(){

        },

        onSelect(row){           
            this.$refs["qty"+row.id].focus(true);
            this.$refs["qty"+row.id].$refs["input"].select();    

        },

        onDblClick(row){
            this.$toast.open('Открываем проект ' + row.title);
            console.dir(this.$axios);
        },

        confirmDelete() {
            let projectTitle = this.selected.title;
            this.$dialog.confirm({
                title: 'Удаление проекта',
                message: 'Вы уверены, что хотите <b>удалить</b> проект "' + projectTitle + '"? Данные проекта будут безвозвратно уничтожены.',
                cancelText: 'Отмена',
                confirmText: 'Удалить',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {                    
                    this.deleteItem(this.selected);
                }
            })
        },

        deleteItem(item){
            console.log('deleting: ' + item);
            let itemTitle = item.title;
            this.items.splice(this.items.indexOf(item), 1);
            this.$toast.open('Проект "'+ itemTitle +'" удалён');
            this.selected = null;
        },

        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
        },

        sortText(a, b, isAsc){
            //console.dir(this.sortField);
            //var collator = new Intl.Collator(undefined, {sensitivity: "accent", numeric: true});

            if(!a.hasOwnProperty(this.sortField) || !b.hasOwnProperty(this.sortField)) return 0;
            let comparison = a[this.sortField].localeCompare(b[this.sortField], this.$locale, {sensitivity: "accent", numeric: true});
            return ( isAsc ) ? (comparison * -1) : comparison
        },

        sortDateCreated(a, b, isAsc){
            if(!a.hasOwnProperty(this.sortField) || !b.hasOwnProperty(this.sortField)) return 0;
            let aDate = new Date(a.dateCreated).getTime();
            let bDate = new Date(b.dateCreated).getTime();
            if (aDate === bDate) {return 0}
           if (isAsc) {
               return aDate > bDate ? 1 : -1;  
              } else  {
               return bDate > aDate ? 1 : -1;  
            }
        },

        sortDateSaved(a, b, isAsc){
            if(!a.hasOwnProperty(this.sortField) || !b.hasOwnProperty(this.sortField)) return 0;
            let aDate = new Date(a.dateSaved).getTime();
            let bDate = new Date(b.dateSaved).getTime();
            if (aDate === bDate) {return 0}
           if (isAsc) {
               return aDate > bDate ? 1 : -1;  
              } else  {
               return bDate > aDate ? 1 : -1;  
            }
        },

        reindexData(data){
                this.items.forEach( function(item, idx) {
                    item.uuid = createUniqueString();
                    item.id = idx+1;
                    item.dateCreated = new Date(item.dateCreated).toLocaleDateString("ru",{month: 'numeric', day: 'numeric', year: 'numeric'})
                    item.dateSaved = new Date(item.dateSaved).toLocaleDateString("ru",{month: 'numeric', day: 'numeric', year: 'numeric'})

                })
        }
    },

    created(){
        //setListType(this.params.listType);
        this.reindexData();
        
    },

    mounted(){
        

    }
}
</script>

<style lang="scss">
.toolbar{
    display: flex;
    border: 1px solid #ccc;
    flex-flow: column;
    clear: both;
}
.is-fixed{
    position:fixed;
}
.project-list{
    width:100%;
    user-select: none;
    height: 500px;
    overflow: scroll;
}

.project-list thead th {
    position: sticky; top: 0; 
    background: rgb(230, 230, 230);
}

.project-list table:focus {
    
    box-shadow: none !important;; 
    outline-style: none !important;
}

.project-list tr > td{
    vertical-align: middle;
    padding: .4rem 1rem;
}
.project-list tr > td.status > span{
    display: flex;
    justify-content: center;
}

.project-list tr > td.status .control-label{
    display:none;
}

* table{
    border-collapse: collapse !important;
}

$list-odd-row-color: rgba(137, 160, 183, 0.1);

input[type="number"]{
    text-align: right;
}


input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button{
 -webkit-appearance: none;
  margin: 0;
}

input[type="number"].with-arrows:focus::-webkit-inner-spin-button,
input[type="number"].with-arrows:hover::-webkit-inner-spin-button{
  opacity: 1;
}

input[type=number].with-arrows::-webkit-inner-spin-button,
input[type=number].with-arrows::-webkit-outer-spin-button{
-webkit-appearance: unset;
opacity: .4;
padding: 1rem 0;
margin-right: -8px;
margin-left: 6px;
}

.list-wrapper{
    display: flex;
    flex-flow: column;
    width: 100%;
    margin: 1rem;

    border-radius: 2px;
}

.list-header{
    background: #eee;
    border-bottom: 1px solid #ddd;
    font-size: 1.3rem;
    text-shadow: #fff 0 1px 0;
}

.list-toolbar{
    display: flex;
    background: #eee;
    border-bottom: 1px solid #ddd;
    flex-flow: row;
}

.list-toolbar input{
    background-color: #fff;
    background-position: right 8px center;
    background-repeat: no-repeat;
    border: 1px solid #d1d5da;
    border-radius: 2px;
    box-shadow: inset 0 1px 2px rgba(27,31,35,.075);
    color: #24292e;
    outline: none;
    padding: 6px 8px;
    vertical-align: middle;
}


.list-table{
    display: flex; 
    flex-wrap: nowrap;
    flex-direction: column;
    width: 100%;    
    border: 1px solid #ccc;
}

.list-table li{
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px dotted #ccc;

}

.list-table > li:nth-of-type(odd) {
    background-color: $list-odd-row-color;
}

.list-table > li:last-child {
    border-bottom: none;
}

.list-table li span{
    padding: .3rem 1rem;    
}

.list-table li .item-title{
    flex-basis: 4rem;
    flex-grow: 1;
}

.list-table  li:hover .item-actions{
    visibility: visible;
}
.list-table .item-actions{
    visibility: hidden;
}
.list-table .item-actions button{
    cursor: pointer
}
</style>
